import {DateTime} from 'luxon';
import {
  ContentFeed,
  ContentFeedUploadMethod,
  RemoteContentFeed,
  RemoteContentFeedHistoryUpdate,
} from 'common/src/modules/contentFeeds/contentFeeds.types';
import { GoogleSheetDetails } from '../feeds/feeds.types';

export function toClientContentFeed(feed: RemoteContentFeed): ContentFeed {
  return {
    clientId: feed.clientId,
    createdByUsername: feed.createdByUsername,
    id: feed.id,
    itemsCount: feed.itemsCount,
    matchedFields: feed.matchedFields,
    name: feed.name,
    unmatchedFields: feed.unmatchedFields,
    updatedByUsername: feed.updatedByUsername,
    usedInCampaigns: feed.usedInCampaigns,
    createdTime: DateTime.fromISO(feed.createdTime),
    updatedTime: DateTime.fromISO(feed.updatedTime),
    lastInventoryUpdateTime: feed.lastInventoryUpdateTime
      ? DateTime.fromISO(feed.lastInventoryUpdateTime)
      : undefined,
    scheduledJob: feed.scheduledJob,
    feedSource:
      feed.uploadMethod === ContentFeedUploadMethod.GoogleSheet
        ? {
            googleSheetDetails: feed.googleSheetDetails as GoogleSheetDetails,
            uploadMethod: ContentFeedUploadMethod.GoogleSheet,
          }
        : {
            itemsFileUrl: feed.itemsFileUrl,
            uploadMethod: feed.uploadMethod,
          },
  };
}

export function toClientFeedUpdateHistory(feedUpdate: RemoteContentFeedHistoryUpdate) {
  return {
    ...feedUpdate,
    startTime: DateTime.fromISO(feedUpdate.startTime),
    endTime: DateTime.fromISO(feedUpdate.endTime),
  };
}
